// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__T3iUrqtM","error":"Captcha_error__km-Mut0z"};